import React from "react";
import App from "./App";
import "./App.css";

function Main() {
    return <App />;
}
export default Main;
